// Copyright ©️ 2026 eVolve MEP, LLC

import type { TaskAssigneeTaskInProgress } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import { VariableTrackingModal } from 'components/Mantine/Modals/VariableTrackingModal';
import { stringListToNaturalLanguage } from 'helpers/stringFunctions';
import { validateUserNameOrEmail } from 'helpers/userHelpers';

const renderOtherTasks = (blockedAssignees: TaskAssigneeTaskInProgress[]) => {
  const uniqueTaskNames = [...new Set(blockedAssignees.map(({ taskName }) => taskName))];
  return (
    <>
      <Text>
        <b>{stringListToNaturalLanguage(blockedAssignees.map(({ user }) => validateUserNameOrEmail(user)))}</b>{' '}
        {blockedAssignees.length > 1 ? 'are' : 'is'} currently active on{' '}
        {uniqueTaskNames.length > 1 ? 'running tasks' : 'a running task'},{' '}
        <b>{stringListToNaturalLanguage(uniqueTaskNames)}</b>
      </Text>
      <Text fw={500}>Enabling them here will disable them on other running tasks!</Text>
    </>
  );
};

export const AssigneesAlreadyActiveModal = ({
  blockedAssignees,
  onClose,
  onConfirm,
}: {
  blockedAssignees: TaskAssigneeTaskInProgress[] | null;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <VariableTrackingModal
    title="Active assignees"
    variable={blockedAssignees}
    onClose={onClose}
    onConfirm={onConfirm}
    confirmationText="Continue"
  >
    {renderOtherTasks}
  </VariableTrackingModal>
);
